import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage, isSupported as isMessagingSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAnm8V217rAFWXI5LxxmUEwGI_-Nzbe6RM",
  authDomain: "huamachuco-c0d9f.firebaseapp.com",
  projectId: "huamachuco-c0d9f",
  storageBucket: "huamachuco-c0d9f.firebasestorage.app",
  messagingSenderId: "159537945910",
  appId: "1:159537945910:web:f70c13700159f848d1e797",
  measurementId: "G-CHMV3GKSRM"
};

/*
const firebaseConfig = {
  apiKey: "AIzaSyASi2ao3U8-D1rhdXfU-wUxji7PR_1muMo",
  authDomain: "av10dejulio-2ecc3.firebaseapp.com",
  projectId: "av10dejulio-2ecc3",
  storageBucket: "av10dejulio-2ecc3.appspot.com",
  messagingSenderId: "910468348910",
  appId: "1:910468348910:web:dd9a81bc1181a385dcacff",
  measurementId: "G-SZK5LL9Y14"
};

*/


const app = initializeApp(firebaseConfig);

// Auto-detect: usa WebSocket si está disponible, fallback a long polling si está bloqueado.
// experimentalForceLongPolling causaba timeouts de 15-30s en condiciones normales.
export const db = initializeFirestore(app, { experimentalAutoDetectLongPolling: true });
export const auth = getAuth(app);
export const storage = getStorage(app);
export { app };

/** URL para Cloud Functions HTTP. Dev: proxy Vite. Producción: /api/... (rewrite mismo origen, sin CORS). */
export const getCloudFunctionsHTTPUrl = (functionName) => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `/api/${functionName}`;
  }
  const projectId = firebaseConfig.projectId || app?.options?.projectId;
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/${functionName}`;
};

/** URL absoluta para fallback cuando un rewrite/proxy local no estÃ¡ disponible. */
export const getCloudFunctionsHTTPAbsoluteUrl = (functionName) => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/${functionName}`;
};

/** URL absoluta para consultarTag (RUT → tagtotal.cl scraping). */
export const getConsultarTagHTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/consultarTag`;
};

/** URL absoluta para activarPremiumPromo1MHTTP (evita 404 si el rewrite de Hosting no aplica). La función tiene CORS para kawescar.cl y localhost. */
export const getActivarPremiumPromo1MHTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/activarPremiumPromo1MHTTP`;
};

/** URL absoluta para reenviarCorreoOnboardingEtapa1HTTP (CORS para localhost). */
export const getReenviarCorreoOnboardingEtapa1HTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/reenviarCorreoOnboardingEtapa1HTTP`;
};

/** URL absoluta para sendActivationNotificationsHTTP (CORS para localhost). */
export const getSendActivationNotificationsHTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/sendActivationNotificationsHTTP`;
};

/** URL absoluta para createSolicitudProductoHTTP (CORS para dashboard proveedor). */
export const getCreateSolicitudProductoHTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/createSolicitudProductoHTTP`;
};

/** URL absoluta para createSolicitudCampanaHTTP (CORS para dashboard proveedor). */
export const getCreateSolicitudCampanaHTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/createSolicitudCampanaHTTP`;
};

/** URL absoluta para createProductHTTP (CORS para admin aprobar solicitud desde localhost). */
export const getCreateProductHTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/createProductHTTP`;
};

/** URL absoluta para createCampaignHTTP (CORS para admin aprobar solicitud desde localhost). */
export const getCreateCampaignHTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/createCampaignHTTP`;
};

/** URL absoluta para adminSolicitudOpsHTTP (editar/rechazar solicitudes sin writes directos). */
export const getAdminSolicitudOpsHTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/adminSolicitudOpsHTTP`;
};

export const getCheckClientEmailExistsHTTPUrl = () => {
  const projectId = firebaseConfig.projectId || app?.options?.projectId || "huamachuco-c0d9f";
  const region = "us-central1";
  return `https://${region}-${projectId}.cloudfunctions.net/checkClientEmailExistsHTTP`;
};

if (!db) {
  console.error('❌ Error: Firebase Firestore (db) no se inicializó correctamente');
}

// Inicializar messaging solo si está en el navegador y el service worker está disponible
let messaging = null;

// Función asíncrona para inicializar messaging de forma segura
const initializeMessaging = async () => {
  // Verificar que estamos en el navegador
  if (typeof window === 'undefined') {
    return null;
  }

  // Verificar soporte básico de Service Worker y APIs necesarias
  if (!('serviceWorker' in navigator) || 
      !('PushManager' in window) || 
      !('Notification' in window)) {
    return null;
  }

  try {
    // Verificar si el navegador soporta Firebase Messaging
    // isMessagingSupported() puede lanzar un error si el navegador no es compatible
    let isSupported = false;
    try {
      isSupported = await isMessagingSupported();
    } catch (supportError) {
      // Si isMessagingSupported() lanza un error, el navegador no es compatible
      if (supportError.code === 'messaging/unsupported-browser' || 
          supportError.message?.includes('unsupported-browser') ||
          supportError.message?.includes("doesn't support the API")) {
        return null;
      }
      // Para otros errores, también retornar null
      return null;
    }
    
    if (!isSupported) {
      return null;
    }

    // Solo inicializar si está soportado
    messaging = getMessaging(app);
    return messaging;
  } catch (error) {
    // Capturar errores de manera silenciosa para no romper la aplicación
    // Específicamente capturar errores de navegador no soportado
    if (error.code === 'messaging/unsupported-browser' || 
        error.message?.includes('unsupported-browser') ||
        error.message?.includes("doesn't support the API")) {
      // Navegador no soportado - esto es esperado en algunos navegadores
      return null;
    }
    // Para otros errores, también retornar null silenciosamente
    return null;
  }
};

// Inicializar messaging de forma asíncrona (no bloquea la carga de la app)
// Usar una promesa que se resuelve silenciosamente para evitar errores no manejados
if (typeof window !== 'undefined') {
  // Usar Promise.resolve().then() para manejar la promesa de forma segura
  Promise.resolve(initializeMessaging()).catch(() => {
    // Error silencioso - el navegador simplemente no soporta messaging
    // No hacer nada, messaging permanecerá null
  });
}

export { messaging };
